<h1 mat-dialog-title>My Assessment Feedback is...</h1>
@if (isProlongationSubmitted() && isSettledSubmitted()) {
<mat-radio-group
  class="radioButton"
  aria-label="Select an option"
  [(ngModel)]="radio">
  <mat-radio-button
    class="radioButtons"
    value="settle"
    >Settle this recommendation</mat-radio-button
  ><br />
  @if (!checkArea('GPIA')) {
  <mat-radio-button
    class="radioButtons"
    value="prolong"
    >Ask for Deadline Prolongation</mat-radio-button
  >
  }
</mat-radio-group>
} @if (dialogForm) {
<div
  mat-dialog-content
  [formGroup]="dialogForm">
  @if (checkAction('settle')) {
  <p>My settling remark is</p>
  } @if (checkAction('settle')) {
  <div class="settle">
    <div>
      <app-editor
        [form]="dialogForm"
        controlName="commentExecution" />
    </div>
    @if (dialogForm.controls.commentExecution.status === 'INVALID' && dialogForm.touched) {
    <div class="errorText">Remark is required</div>
    }
  </div>
  } @if (checkAction('settle')) {
  <div>
    <mat-form-field class="textField">
      <input
        matInput
        formControlName="amountCapex"
        placeholder="Amount of CAPEX in CHF used" />
    </mat-form-field>
  </div>
  }
  <!-- !!! GPRM only !!! -->
  @if (checkAction('prolong')) {
  <div class="prolongation">
    <div>
      <mat-form-field class="textField">
        <input
          matInput
          [matDatepicker]="picker"
          formControlName="prolongationDeadline"
          placeholder="I ask for Prolongation until" />
        <mat-datepicker-toggle
          matSuffix
          [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error>New date has to be after Initial Deadline and today</mat-error>
      </mat-form-field>
    </div>
    <div>
      <p>The reason is:</p>
    </div>
    <div>
      <mat-form-field class="textField">
        <input
          matInput
          formControlName="shortText2"
          placeholder="Prolongation reason" />
      </mat-form-field>
    </div>
  </div>
  } @if (checkAction('prolong') || checkAction('settle')) {
  <div class="buttons">
    @if (!checkAction('prolong') && isProlongationSubmitted() && isSettledSubmitted()) {
    <button
      mat-raised-button
      (click)="settleRecommendation()"
      class="settle">
      Settle Recommendation
    </button>
    } @if (checkAction('prolong') && isSettledSubmitted() && isProlongationSubmitted()) {
    <button
      mat-raised-button
      (click)="askForProlongation()"
      class="settle">
      Ask for Prolongation
    </button>
    }
    <button
      mat-raised-button
      [mat-dialog-close]="true">
      Cancel
    </button>
  </div>
  }
</div>
}
